import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'is-mobile';
import ClickOutside from '../../ClickOutside';
import CalendarOptionButton from '../CalendarOptionButton';
import CalendarOptionsTodayButton from './CalendarOptionsTodayButton';

const CalendarOptionsMenu = ({
  calendarViewSelectTitle,
  calendarSelectTitle,
  onIconClick,
  calendarSelect,
  calendarViewSelect,
  ...props
}) => {
  const [openCalendarSelect, setCalendarSelectToggle] = useState(false);
  const [openCalendarViewSelect, setCalendarViewSelectToggle] = useState(false);
  const handleClickOutside = () => {
    setCalendarSelectToggle(false);
    setCalendarViewSelectToggle(false);
  };

  return (
    <div className='calendar__options' {...props}>
      <div className='calendar__options__menu between-xs start-md'>
        <div className='calendar__options__menu__item'>
          {onIconClick && (
            <CalendarOptionsTodayButton
              className='mr-1x CalendarOptionsTodayButton'
              onClick={onIconClick}
            />
          )}
          {calendarSelect && (
            <CalendarOptionButton
              className='pl-1x'
              isOpen={openCalendarSelect}
              onClick={() => {
                setCalendarSelectToggle(!openCalendarSelect);
                setCalendarViewSelectToggle(false);
              }}
              title={calendarSelectTitle}
            />
          )}
        </div>
        {calendarViewSelect && (
          <CalendarOptionButton
            className='calendar__options__menu__item'
            isOpen={openCalendarViewSelect}
            onClick={() => {
              setCalendarViewSelectToggle(!openCalendarViewSelect);
              setCalendarSelectToggle(false);
            }}
            title={calendarViewSelectTitle}
          />
        )}
      </div>
      {(openCalendarSelect || openCalendarViewSelect) && (
        <Fragment>
          <ClickOutside handleClickOutside={handleClickOutside}>
            <div
              className={`calendar__options__calendar__select ${isMobile() &&
                'calendar__options__calendar__select--mobile-view'}`}
            >
              <div className='card'>
                {openCalendarSelect
                  ? calendarSelect && calendarSelect
                  : calendarViewSelect &&
                    calendarViewSelect(setCalendarViewSelectToggle)}
              </div>
            </div>
          </ClickOutside>
          <div className='calendar__options__background-overlay' />
        </Fragment>
      )}
    </div>
  );
};

CalendarOptionsMenu.propTypes = {
  calendarSelectTitle: PropTypes.string,
  calendarViewSelectTitle: PropTypes.string,
  onIconClick: PropTypes.func,
  calendarSelect: PropTypes.node,
  calendarViewSelect: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

export default CalendarOptionsMenu;
